import React, { useState, useCallback, useEffect } from "react";
import styled from "styled-components";

import CheckListComponent from "../Components/TreatmentPage/components/ChecklistSection";
import mixColorWithWhite, {
  formatDateVisitsDates,
  formatPanelDate,
} from "../Components/TreatmentPage/utils/helperFn";
import NewEditCaseProviderModal from "../Components/BP/modals/NewEditCaseProviderModal";
import GenrateDocument from "../Components/GenrateDocument/GenrateDocument";
import ClientProvidersStyles from "../Components/CaseDashboard/ClientProvidersStyles";
import {
  addClickRecord,
  currencyFormat,
  formatCalendarDate,
  formatTimestampDate,
  formatPhoneNumber,
  getCaseId,
  getClientId,
} from "../Utils/helper";
import checkUpload from "../../public/BP_resources/images/icon/check upload.svg";
import grayDoc from "../../public/BP_resources/images/icon/documents-icon-gray.svg";
import costIcon from "../../public/BP_resources/images/icon/costs-icon-color.svg";
import EditMedicalBill from "../Components/TreatmentPage/modals/edit-medical-bill/editMedicalBill";
// import CostReqIcon from "../assets/cost-request-icon.svg";
// import ContactPanelForTreatment from "../Components/TreatmentPage/components/ContactPanelForTreatment";
import SendEmailBtnTreatment from "../Components/TreatmentPage/components/SendEmailBtnTreatment";
import ProviderHistoryButton from "../Components/TreatmentPage/components/ProviderHistoryButton";
import TreatmentFirstStatus from "../Components/TreatmentPage/components/TreatmentFirstStatus";
import FaxIcon from "../assets/fax.svg";
import FaxIconGrey from "../assets/fax-icon-greyscale.svg";
import CostRequestDetailedModal from "../Components/common/modals/CostRequestDetailedModal";
import FaxWorkflowModal from "../Components/FaxWorkflow/FaxWorkflowModal";
import { checkPendingCost } from "../Hooks/checkPendingCosts";
import { useDropdownTemplateAvailability } from "../Hooks/useGetTemplates";

const NameContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: start;
  color: white;
  font-weight: 700;
  font-size: 16px;
  background-color: ${({ speciality }) => speciality.color};
  height: 50px;
  // width: 485px;
  position: relative;

  // Add trapezium shapes to the left and right
  &::before {
    content: "";
    position: absolute;
    top: 0;
    height: 0;
    width: 0;
    border-bottom: 0px solid ${({ speciality }) => speciality.color};
  }
  &::after {
    content: "";
    position: absolute;
    top: 0;
    height: 0;
    width: 0;
    border-bottom: 50px solid ${({ speciality }) => speciality.color};
  }
  &::before {
    left: -5px;
    border-left: 5px solid transparent;
  }
  &::after {
    right: -10px;
    border-right: 10px solid transparent;
  }
`;
const TreatmentPageSimplePage = ({
  specialitiesList,
  caseProvider,
  firmName,
  refetchAll,
  // maxWidth,
  treatmentDateData,
  tableRef,
  setWidthName,
}) => {
  const { templatesAvailable: providerLocationTemplatesAvailable } =
    useDropdownTemplateAvailability(8, 3);
  const [dates, setDates] = useState([
    {
      date: caseProvider?.first_date !== "__/__/___" ? caseProvider?.first_date?.split("T")[0] : "",
    },
    {
      date:
        caseProvider?.second_date !== "__/__/___" ? caseProvider?.second_date?.split("T")[0] : "",
    },
  ]);
  const [visits, setVisits] = useState(caseProvider?.visits);
  const toggleModal = useCallback((setter, value) => () => setter(value), []);

  const [activeTab, setActiveTab] = useState("Treatment-Location");

  const [caseProviderShow, setCaseProviderShow] = useState(false);
  const handleCaseProviderClose = toggleModal(setCaseProviderShow, false);
  const handleCaseProviderShow = (tabName) => {
    setCaseProviderShow(true);
    setActiveTab(tabName);
  };
  const [allTreatmentDates, setAllTreatmentDates] = useState([]);

  const [instanceIdForGenragteDoc, setInstanceIdForGenragteDoc] = useState();
  const [showGenerateDocument, setShowGenerateDocument] = useState(false);
  const [showFaxWorkflow, setShowFaxWorkflow] = useState(false);
  const [costRequestModalProps, setCostRequestModalProps] = useState(null);
  const [dropdownName, setDropdownName] = useState("");
  const [pendingCostExists, setPendingCostExists] = useState({});

  const refreshPendingCost = useCallback(async () => {
    const case_id = getCaseId();
    const client_id = getClientId();
    const source_object_id = caseProvider?.id;

    if (!case_id || !client_id || !source_object_id) {
      setPendingCostExists({});
      return;
    }

    const sourceKeys = ["records_request_paid", "billing_request_paid"];
    const checks = await Promise.all(
      sourceKeys.map(async (source_key) => ({
        source_key,
        exists: await checkPendingCost({
          case_id,
          client_id,
          source_object: "CaseProviders",
          source_object_id,
          source_key,
        }),
      }))
    );

    setPendingCostExists(
      checks.reduce((acc, { source_key, exists }) => {
        acc[source_key] = exists;
        return acc;
      }, {})
    );
  }, [caseProvider?.id]);

  const handleGenrateDocument = (instanceId, name) => {
    setInstanceIdForGenragteDoc(instanceId);
    setDropdownName(name);
    setShowGenerateDocument(true);
    addClickRecord(999, 8);
  };

  const [tfData, setTFData] = useState({
    original: 0,
    hi_paid: 0,
    hi_reduction: 0,
    mp_paid: 0,
    reduction: 0,
    patient_payment_value: 0,
    liens: 0,
  });
  const [showMedicallBill, setShowMedicalBill] = useState(false);
  const [medBillData, setMedBillData] = useState(null);

  const handleMedBillClose = () => {
    setShowMedicalBill(false);
    // refetchAll();
    addClickRecord(999, 8);
  };

  const handleMedBillShow = (type, providerData) => {
    addClickRecord(999, 8);
    if (type === "caseProvider") {
      caseProvider?.tf_accounting?.map((item) => {
        setTFData({
          original: item?.original,
          hi_paid: item?.hi_paid,
          hi_reduction: item?.hi_reduction,
          mp_paid: item?.mp_paid,
          reduction: item?.reduction,
          patient_payment_value: item?.patient_payment_value,
          liens: item?.liens,
        });
      });
      setMedBillData(providerData);
      setShowMedicalBill(true);
    }
    if (type === "tf") {
      setMedBillData({
        id: caseProvider.id,
        amount: caseProvider.original,
        ins_paid: caseProvider.hi_paid,
        write_off: caseProvider.hi_reduction,
        medpaypaip: caseProvider.mp_paid,
        reduction: caseProvider.reduction,
        patient_paid: caseProvider.patient_payment_value,
      });
      setShowMedicalBill(true);
    }
    if (type === "number") {
      setMedBillData({
        amount: 0,
        ins_paid: 0,
        write_off: 0,
        medpaypaip: 0,
        reduction: 0,
        patient_paid: 0,
      });
      setShowMedicalBill(true);
    }
  };

  const PanelGenereateButtons = [
    {
      iconClassName: "ic ic-19 ic-generate-document",
      buttonText: "Letter",
      className: "p-l-6 p-r-5",
      style: { height: "25px" },
      onClick: (id, genDocId) => {
        addClickRecord(999, 8);
        handleGenrateDocument(id, genDocId);
      },
    },
  ];

  const matchedProviders = treatmentDateData?.filter(
    (item) => item?.client_provider?.id === caseProvider?.id
  );

  const _lastProvider =
    matchedProviders?.length > 0 ? matchedProviders[matchedProviders.length - 1] : null;
  const costRequestDisabled =
    !!pendingCostExists.records_request_paid && !!pendingCostExists.billing_request_paid;
  const costRequestTabs = [
    {
      id: "records_request_paid",
      label: "Pay for Records Request",
      disabled: !!pendingCostExists.records_request_paid,
      source_key: "records_request_paid",
      name: caseProvider?.records_request_paid?.name,
      address1: caseProvider?.records_request_paid?.address1,
      address2: caseProvider?.records_request_paid?.address2,
      city: caseProvider?.records_request_paid?.city,
      state: caseProvider?.records_request_paid?.state,
      zip_code: caseProvider?.records_request_paid?.zip,
      email: caseProvider?.records_request_paid?.email,
      phone_number: caseProvider?.records_request_paid?.phone_number,
      fax_number: caseProvider?.records_request_paid?.fax,
      amount: 0,
      cost_name: "Records Cost Paid",
      category_suffix: "Records Request Payment",
    },
    {
      id: "billing_request_paid",
      label: "Pay for Billing Request",
      disabled: !!pendingCostExists.billing_request_paid,
      source_key: "billing_request_paid",
      name: caseProvider?.billing_request_paid?.name,
      address1: caseProvider?.billing_request_paid?.address1,
      address2: caseProvider?.billing_request_paid?.address2,
      city: caseProvider?.billing_request_paid?.city,
      state: caseProvider?.billing_request_paid?.state,
      zip_code: caseProvider?.billing_request_paid?.zip,
      email: caseProvider?.billing_request_paid?.email,
      phone_number: caseProvider?.billing_request_paid?.phone_number,
      fax_number: caseProvider?.billing_request_paid?.fax,
      amount: 0,
      cost_name: "Billing Paid",
      category_suffix: "Billing Request Payment",
    },
  ];

  const adjustCaseDetailsWidths = () => {
    const columns = document.querySelectorAll(".treatment-provider-name");
    const BASELINE = 245;

    // reset first, otherwise you measure last frame's forced width
    columns.forEach((c) => (c.style.width = "auto"));

    let maxWidth = BASELINE;
    columns.forEach((c) => {
      maxWidth = Math.max(maxWidth, c.getBoundingClientRect().width);
    });
    setWidthName(maxWidth);

    if (maxWidth === BASELINE) {
      columns.forEach((c) => (c.style.width = `${maxWidth}px`));
      columns.forEach((c) => (c.style.maxWidth = `${maxWidth}px`));
    } else {
      columns.forEach((c) => (c.style.width = `${maxWidth + 10}px`));
      columns.forEach((c) => (c.style.maxWidth = `${maxWidth + 10}px`));
    }
    // columns.forEach((c) => (c.style.width = `${maxWidth}px`));
  };

  useEffect(() => {
    adjustCaseDetailsWidths();
    window.addEventListener("resize", adjustCaseDetailsWidths);
    return () => {
      window.removeEventListener("resize", adjustCaseDetailsWidths);
    };
  }, [caseProvider]);

  useEffect(() => {
    const variableMedBillWidth = () => {
      const currencyColumns = [...document.querySelectorAll(".med-bill-width")];
      const providerColumns = [...document.querySelectorAll(".provider-treatment-col")];
      if (currencyColumns.length === 0 || providerColumns.length === 0) return;
      if (caseProvider) {
        let currencyMaxWidth = 0;
        currencyColumns.forEach((col) => {
          const colWidth = col.offsetWidth;
          if (colWidth > currencyMaxWidth) {
            currencyMaxWidth = colWidth;
          }
        });
        // Apply the maximum width to all columns
        currencyColumns.forEach((col) => {
          col.style.minWidth = `${currencyMaxWidth}px`;
          col.style.width = `${currencyMaxWidth}px`;
        });

        let providerMaxWidth = 0;
        providerColumns.forEach((col) => {
          const colWidth = col.offsetWidth;
          if (colWidth > providerMaxWidth) {
            providerMaxWidth = colWidth;
          }
        });
        // Apply the maximum width to all columns
        providerColumns.forEach((col) => {
          col.style.minWidth = `${providerMaxWidth}px`;
          col.style.width = `${providerMaxWidth}px`;
        });
      }
    };

    // setMaxColumnWidth(calculateMaxWidth());
    variableMedBillWidth();
  }, [caseProvider]);

  useEffect(() => {
    refreshPendingCost();
  }, [refreshPendingCost]);

  const missingVisitCount =
    visits === null || visits === undefined || visits === "" || !Number.isFinite(Number(visits));
  const firstVisitDate = formatDateVisitsDates(dates[0]?.date);
  const lastVisitDate = formatDateVisitsDates(dates[1]?.date);

  return (
    <div className={`treatment-provider has-speciality-color-${specialitiesList?.id}`}>
      <ClientProvidersStyles
        clientProviders={[
          {
            specialty: {
              ...specialitiesList,
            },
          },
        ]}
      />
      {caseProviderShow && (
        <NewEditCaseProviderModal
          show={caseProviderShow}
          firmName={firmName}
          handleClose={() => {
            addClickRecord(999, 8);
            handleCaseProviderClose();
          }}
          visits={visits}
          dates={dates}
          setDates={setDates}
          setVisits={setVisits}
          caseProvider={caseProvider}
          specialitie={specialitiesList}
          contact={caseProvider?.treatment_location}
          treatmentBill={caseProvider?.billing_request}
          paidBill={caseProvider?.billing_request_paid}
          treatmentRecord={caseProvider?.records_request}
          paidRecords={caseProvider?.records_request_paid}
          lienHolder={caseProvider?.lien_holder}
          allTreatmentDates={allTreatmentDates}
          setAllTreatmentDates={setAllTreatmentDates}
          verification={caseProvider?.verification?.verification_info}
          refetchAll={refetchAll}
          refetch={refetchAll}
          activeTab={activeTab}
          setActiveTab={setActiveTab}
        />
      )}

      <div>
        <div
          style={{
            height: "50px",
            width: "100%",
          }}
          className="d-flex bg-speciality-10"
        >
          <NameContainer
            style={{
              paddingLeft: "10px",
              paddingRight: "30px",
              // minWidth: maxWidth > 245 ? maxWidth : maxWidth,
              fontWeight: "700",
              // flex: "1 1 auto",
              // marginRight: "5px",
              // overflow: "hidden",
              // textOverflow: "ellipsis",
              // display: "-webkit-box",
              // WebkitLineClamp: 1,
              // WebkitBoxOrient: "vertical",
            }}
            className=""
            speciality={specialitiesList}
          >
            <div className="d-flex flex-column">
              <div
                className="height-21"
                style={{
                  color: mixColorWithWhite(specialitiesList?.color, 20),
                }}
              >
                {specialitiesList?.name.toUpperCase()}
              </div>
              <div
                className="height-21 treatment-provider-name"
                style={{
                  fontSize: "16px",
                  overflow: "hidden",
                  textOverflow: "ellipsis",
                  display: "-webkit-box",
                  WebkitLineClamp: 1,
                  WebkitBoxOrient: "vertical",
                }}
              >
                {" "}
                {caseProvider?.treatment_location?.name}
              </div>
            </div>
            <TreatmentFirstStatus
              provider={caseProvider}
              specialty={specialitiesList}
              refetchAll={refetchAll}
            />
          </NameContainer>

          {/* Center Section */}
          <div
            className="d-flex justify-content-center align-items-end flex-column"
            style={{
              position: "relative",
              left: "0px",
              flex: "1",
              // flex: "0 0 12px",
              // minWidth: "12px",
            }}
          >
            <div
              className="bg-speciality"
              style={{
                width: "100%",
                position: "absolute",
                top: "0px",
                height: "5px",
              }}
            >
              {/*  */}
            </div>
            <div className="treatment-header-history">
              <ProviderHistoryButton
                providerId={caseProvider?.attorney_created_provider}
                specialty={specialitiesList}
                providerName={caseProvider?.treatment_location?.name}
                treatmentFirstConnected={
                  caseProvider?.is_accepted === true ||
                  caseProvider?.attorney_details?.is_accepted === true
                }
              />
            </div>
          </div>

          {/* Right Section */}
          <div
            style={{
              width: "180px",
              flexShrink: 0,
            }}
            className="d-flex justify-content-end align-items-center "
          >
            <CheckListComponent speciality={specialitiesList} provider={caseProvider} />
          </div>
        </div>
        <div
          style={{
            //  marginLeft: "27px",
            marginTop: "5px",
            // marginBottom: "5px",
            "--treatment-panel-background": `var(--speciality${specialitiesList?.id}-4, var(--primary-4))`,
          }}
          className="d-flex treatment-panel-rows"
        >
          <div
            onClick={() => {
              addClickRecord(999, 8);
              handleCaseProviderShow("Treatment-Location");
            }}
            style={{
              minWidth: "255px",
              maxWidth: "255px",
            }}
          >
            <>
              {caseProvider?.treatment_location?.name?.trim() ? (
                <p
                  style={{ backgroundColor: "var(--primary-2)" }}
                  className="font-weight-semibold text-capitalize bg-speciality-2 p-r-5 p-l-5 text-truncated"
                >
                  {caseProvider?.treatment_location?.name}
                </p>
              ) : (
                <p
                  className="font-weight-semibold text-capitalize bg-speciality-2 p-r-5 p-l-5"
                  style={{
                    backgroundColor: "var(--primary-2)",
                    color: "var(--primary-25)",
                  }}
                >
                  Company Name
                </p>
              )}
              <div>
                <p
                  className="inline-row-h-21 text-capitalize p-r-5 bg-speciality-4 p-l-5"
                  style={{
                    backgroundColor: "var(--primary-4)",
                    overflow: "hidden",
                    display: "-webkit-box",
                    WebkitLineClamp: 1,
                    WebkitBoxOrient: "vertical",
                  }}
                >
                  {caseProvider?.treatment_location?.address1 ||
                  caseProvider?.treatment_location?.address2 ? (
                    <p className="font-weight-semibold ">
                      {caseProvider?.treatment_location?.address1 && (
                        <span>{caseProvider?.treatment_location?.address1}</span>
                      )}
                      {caseProvider?.treatment_location?.address1 &&
                        caseProvider?.treatment_location?.address2 && <span>, </span>}{" "}
                      {/* Render comma only if both addresses exist */}
                      {caseProvider?.treatment_location?.address2 && (
                        <span>{caseProvider?.treatment_location?.address2}</span>
                      )}
                    </p>
                  ) : (
                    <span
                      className="font-weight-semibold text-capitalize"
                      style={{
                        backgroundColor: "var(--primary-4)",
                        color: "var(--primary-25)",
                      }}
                    >
                      Address
                    </span>
                  )}
                </p>

                <p
                  className="inline-row-h-21 text-capitalize bg-speciality-2 p-r-5 p-l-5"
                  style={{
                    backgroundColor: "var(--primary-2)",
                    overflow: "hidden",
                    display: "-webkit-box",
                    WebkitLineClamp: 1,
                    WebkitBoxOrient: "vertical",
                  }}
                >
                  {caseProvider?.treatment_location?.city ? (
                    <span className="font-weight-semibold">
                      {caseProvider?.treatment_location?.city},
                    </span>
                  ) : (
                    <span className="font-weight-semibold" style={{ color: "var(--primary-25)" }}>
                      city,
                    </span>
                  )}{" "}
                  {caseProvider?.treatment_location?.state ? (
                    <span className="font-weight-semibold">
                      {caseProvider?.treatment_location?.state}
                    </span>
                  ) : (
                    <span className="font-weight-semibold" style={{ color: "var(--primary-25)" }}>
                      state
                    </span>
                  )}{" "}
                  {caseProvider?.treatment_location?.zip ? (
                    <span className="font-weight-semibold">
                      {caseProvider?.treatment_location?.zip}
                    </span>
                  ) : (
                    <span
                      className="font-weight-semibold "
                      style={{
                        color: "var(--primary-25)",
                        textTransform: "uppercase",
                      }}
                    >
                      zip
                    </span>
                  )}
                </p>
              </div>
              <div>
                <p
                  className="inline-row-h-21 height-21 p-r-5 p-l-5 bg-speciality-4"
                  style={{
                    backgroundColor: "var(--primary-4)",
                  }}
                >
                  {caseProvider?.treatment_location?.phone_number ? (
                    <span className="font-weight-semibold">
                      {formatPhoneNumber(caseProvider?.treatment_location?.phone_number)}
                    </span>
                  ) : (
                    <span className="font-weight-semibold" style={{ color: "var(--primary-25)" }}>
                      (###) ###-####
                    </span>
                  )}
                  {/* {ext && (
                                <>
                                  <small
                                    className="ms-1 font-weight-semibold"
                                    style={{ color: "var(--primary-25)" }}
                                  >
                                    ext
                                  </small>{" "}
                                  <span className="font-weight-semibold">{ext}</span>
                                </>
                              )} */}
                </p>
              </div>
              <div>
                <p
                  className="inline-row-h-21 height-21 p-r-5 p-l-5 bg-speciality-4"
                  style={{
                    backgroundColor: "var(--primary-4)",
                  }}
                >
                  {caseProvider?.treatment_location?.fax ? (
                    <span className="font-weight-semibold">
                      {formatPhoneNumber(caseProvider?.treatment_location?.fax)}
                    </span>
                  ) : (
                    <span className="font-weight-semibold" style={{ color: "var(--primary-25)" }}>
                      (###) ###-####
                    </span>
                  )}
                  <small
                    className="ms-1 font-weight-semibold"
                    style={{ color: "var(--primary-25)" }}
                  >
                    fax
                  </small>{" "}
                </p>
              </div>
              <div>
                <p
                  className="inline-row-h-21 p-r-5 text-center p-l-5 bg-speciality-2"
                  style={{ backgroundColor: "var(--primary-2)", height: "21px" }}
                >
                  {caseProvider?.treatment_location?.website ? (
                    <a
                      href={
                        caseProvider?.treatment_location?.website.startsWith("https")
                          ? caseProvider?.treatment_location?.website
                          : `https://${caseProvider?.treatment_location?.website}`
                      }
                      target="_blank"
                      className="font-weight-semibold"
                      style={{
                        textDecoration: "none",
                        color: "#0000EE",
                        whiteSpace: "nowrap",
                        overflow: "hidden",
                        textOverflow: "ellipsis",
                        verticalAlign: "middle",
                        maxWidth: "240px",
                      }}
                    >
                      {caseProvider?.treatment_location?.website}
                    </a>
                  ) : (
                    <a className="" style={{ color: "var(--primary-25)", fontWeight: "600" }}>
                      www.websiteurl.com
                    </a>
                  )}
                </p>
              </div>
            </>
          </div>

          <div
            className="flex-g-1"
            onClick={() => {
              handleCaseProviderShow("Treatment-Location");
            }}
            style={{
              minWidth: "255px",
            }}
          >
            <div
              className="d-flex align-items-center p-l-5 p-r-5 justify-content-center bg-speciality-2"
              style={{
                gap: "15px",
                fontWeight: "600",
              }}
            >
              <span>
                <span className={missingVisitCount ? "text-primary-25" : "text-black"}>
                  {missingVisitCount ? "-" : visits}
                </span>
                <span
                  style={{
                    color: "var(--primary-25)",
                  }}
                  className="m-l-5"
                >
                  {Number(visits) === 1 ? "Visit" : "Visits"}
                </span>
              </span>
              <span>
                <span className={firstVisitDate === "--/--/--" ? "text-primary-25" : "text-black"}>
                  {firstVisitDate}
                </span>{" "}
                <span
                  style={{
                    color: "var(--primary-25)",
                  }}
                  className="m-l-5 m-r-5"
                >
                  to
                </span>{" "}
                <span className={lastVisitDate === "--/--/--" ? "text-primary-25" : "text-black"}>
                  {lastVisitDate}
                </span>
              </span>
            </div>
            <div
              className="d-flex align-items-center justify-content-between p-r-5 p-l-5 bg-speciality-4"
              style={{
                gap: "15px",
                fontWeight: "600",
              }}
            >
              <span
                style={{
                  color: "var(--primary-25)",
                }}
              >
                Account #
              </span>
              <span>{caseProvider?.account_number}</span>
            </div>
            <div
              className="d-flex align-items-center justify-content-between p-r-5 p-l-5 bg-speciality-4"
              style={{
                gap: "15px",
                fontWeight: "600",
              }}
            >
              <span
                style={{
                  color: "var(--primary-25)",
                }}
              >
                Records Ordered
              </span>
              <span>{formatPanelDate(caseProvider?.record_ordered)}</span>
            </div>
            <div
              className="d-flex align-items-center justify-content-between p-r-5 p-l-5 bg-speciality-2"
              style={{
                gap: "15px",
                fontWeight: "600",
              }}
            >
              <span
                style={{
                  color: "var(--primary-25)",
                }}
              >
                Bills Ordered
              </span>
              <span>{formatPanelDate(caseProvider?.billing_ordered)}</span>
            </div>
            <div
              className="d-flex align-items-center justify-content-between p-r-5 p-l-5 bg-speciality-4"
              style={{
                gap: "15px",
                fontWeight: "600",
              }}
            >
              <span
                style={{
                  color: "var(--primary-25)",
                }}
              >
                Records Request Paid
              </span>
              <span>{formatPanelDate(caseProvider?.record_paid)}</span>
            </div>
            <div
              className="d-flex align-items-center justify-content-between p-r-5 p-l-5 bg-speciality-2"
              style={{
                gap: "15px",
                fontWeight: "600",
              }}
            >
              <span
                style={{
                  color: "var(--primary-25)",
                }}
              >
                Bills Request Paid
              </span>
              <span>{formatPanelDate(caseProvider?.billing_paid)}</span>
            </div>
          </div>
        </div>
        <div
          className="m-b-5 d-flex align-items-center"
          style={{
            gap: "5px",
          }}
        >
          {PanelGenereateButtons?.map((button, index) => (
            <button
              type="button"
              id={index}
              style={{
                minWidth: "81px",
                width: "100%",
                backgroundColor: "var(--primary-10)",
                borderColor: "var(--primary)",
                color: providerLocationTemplatesAvailable ? "var(--primary)" : "var(--primary-25)",
                ...button.style,
              }}
              className={`btn btn-hover-contact-panel-row font-weight-semibold text-lg height-25 rounded-0 d-flex align-items-center justify-content-center ${button.className}`}
              disabled={!providerLocationTemplatesAvailable}
              onClick={() => button.onClick(caseProvider?.treatment_location?.id, 3)}
            >
              {button.iconClassName && <i className={`${button.iconClassName} me-1`} />}
              {button.imgSrc && (
                <img className={button.imgClassName} src={button.imgSrc} alt="icon" />
              )}
              {button.buttonText}
            </button>
          ))}
          <SendEmailBtnTreatment
            email={caseProvider?.treatment_location?.email}
            specialitie={specialitiesList}
            name={caseProvider?.treatment_location?.name ?? ""}
            pageName={"Treatment"}
          />

          <button
            style={{
              height: "25px",
              width: "100%",
              minWidth: "81px",

              backgroundColor: "var(--primary-10)",
              borderColor: "var(--primary)",
              color: !caseProvider?.treatment_location?.fax
                ? "var(--primary-25)"
                : "var(--primary)",
            }}
            className="btn btn-hover-contact-panel-row font-weight-semibold text-lg height-25 rounded-0 d-flex align-items-center justify-content-center overflow-hidden info_email m-b-0 p-l-6 p-r-6"
            onClick={() => {
              addClickRecord(999, 8);
              setShowFaxWorkflow(true);
            }}
            disabled={!caseProvider?.treatment_location?.fax}
          >
            {/* <i className="ic ic-19 ic-email-3d me-1" /> */}
            {!caseProvider?.treatment_location?.fax ? (
              <>
                <img src={FaxIconGrey} alt="Fax Icon" className="me-1 ic ic-15" />
              </>
            ) : (
              <>
                <img src={FaxIcon} alt="Fax Icon" className="me-1 ic ic-15" />
              </>
            )}
            Fax
          </button>
          <button
            className="btn btn-hover-contact-panel-row font-weight-semibold text-lg height-25 rounded-0 d-flex align-items-center justify-content-center  overflow-hidden info_email m-b-0 p-l-6 p-r-6"
            style={{
              gap: "5px",
              width: "100%",
              background: "var(--primary-10)",
              borderColor: "var(--primary)",
              color: costRequestDisabled ? "grey" : "var(--primary)",
            }}
            onClick={() => setCostRequestModalProps({})}
            disabled={costRequestDisabled}
          >
            <img
              src={costIcon}
              className={`ic ic-15 d-flex align-items-center justify-content-center ${
                costRequestDisabled ? "grayscale" : ""
              } `}
            />
            Cost Request
          </button>
        </div>
        <div className="TreatmentPageGrayPanel me-0" style={{ background: "transparent" }}>
          <div
            className="d-flex-1 position-relative bilings-table no-rl-padding m-0"
            style={{ width: "100%" }}
          >
            <div className="table--no-card rounded-0 border-0 w-100">
              <table
                className="table table-borderless   has-height-25"
                id="tf_provider_table"
                ref={tableRef}
              >
                <thead>
                  <tr className="height-25">
                    <th
                      id="lockedTreatmentPagesPadding"
                      style={{
                        // background: "var(--primary-15)",
                        // width: maxColumnWidth,
                        // minWidth: "128px",
                        verticalAlign: "middle",
                      }}
                      className="text-end bg-primary-5  med-bill-width td-autosize btn-primary-lighter-default color-primary c-font-weight-600"
                      onClick={() => handleMedBillShow("caseProvider", caseProvider)}
                    >
                      Original
                    </th>
                    <th
                      className="bg-primary-5"
                      onClick={() => handleMedBillShow("caseProvider", caseProvider)}
                    />
                    <th
                      id="lockedTreatmentPagesPadding"
                      style={{
                        // background: "var(--primary-15)",
                        verticalAlign: "middle",
                        // width: maxColumnWidth,
                        // minWidth: "128px",
                      }}
                      onClick={() => handleMedBillShow("caseProvider", caseProvider)}
                      className="text-end bg-primary-5 dollar-amount-value td-autosize med-bill-width btn-primary-lighter-default color-primary c-font-weight-600"
                    >
                      Lien
                    </th>
                    <th
                      // style={{ background: "var(--primary-15)" }}
                      onClick={() => handleMedBillShow("caseProvider", caseProvider)}
                      className="bg-primary-5"
                    />

                    <th
                      id="lockedTreatmentPagesPadding"
                      className=" text-end  bg-primary-5 td-autosize c-font-weight-600"
                      style={{
                        color: "var(--primary-25) !important",
                        // background: "var(--primary-15)",
                      }}
                    >
                      <div className="d-flex justify-content-end align-items-center height-25">
                        <span style={{ paddingRight: "2px" }}>Final</span>
                      </div>
                    </th>
                    <th
                      // style={{ background: "var(--primary-15)" }}
                      className="bg-primary-5"
                      onClick={() => handleMedBillShow("caseProvider", caseProvider)}
                    />
                    <th
                      id="lockedTreatmentPagesPadding"
                      className="td-autosize bg-primary-5 text-center c-font-weight-600"
                      style={{
                        color: "var(--primary-25) !important",
                        // background: "var(--primary-15)",
                        verticalAlign: "middle",
                        // minWidth: "163px",
                      }}
                    >
                      Check #
                    </th>
                  </tr>
                </thead>

                <tbody style={{ backgroundColor: "var(--primary-4)" }}>
                  <tr className="bg-speciality-3">
                    <td
                      id="lockedTreatmentPagesPadding"
                      className={`text-end monospace-font dollar-amount-value ${["0", "0.00"].includes(caseProvider.amount.toString()) ? "zero-placeholder" : "black-placeholder"}`}
                      data-value={caseProvider?.amount}
                      onClick={() => handleMedBillShow("caseProvider", caseProvider)}
                    >
                      {currencyFormat(caseProvider?.amount)}
                    </td>
                    <td onClick={() => handleMedBillShow("caseProvider", caseProvider)} />
                    <td
                      id="lockedTreatmentPagesPadding"
                      className={`text-end monospace-font dollar-amount-value ${["0", "0.00"].includes(caseProvider.liens.toString()) ? "zero-placeholder" : "black-placeholder"}`}
                      data-value={caseProvider.liens}
                      onClick={() => handleMedBillShow("caseProvider", caseProvider)}
                    >
                      {currencyFormat(caseProvider.liens)}
                    </td>
                    <td onClick={() => handleMedBillShow("caseProvider", caseProvider)} />

                    <td id="lockedTreatmentPagesPadding" className="s-final">
                      <div className="monospace-font d-flex justify-content-end align-items-center height-25">
                        <input
                          id="lock-input"
                          className={`monospace-font bill-final-${caseProvider.id} text-end bill-final locked-input dollar-amount-value ${["0", "0.00"].includes(caseProvider.final.toString()) ? "zero-placeholder" : "black-placeholder"}`}
                          type="text"
                          data-value={caseProvider.final}
                          placeholder={
                            caseProvider.final ? currencyFormat(caseProvider.final) : "$ 0.00"
                          }
                        />
                      </div>
                    </td>

                    <td
                      id="lockedTreatmentPagesPadding"
                      className="s-verify"
                      onClick={(e) => e.stopPropagation()}
                    >
                      <img src={grayDoc} />
                    </td>

                    <td
                      id="lockedTreatmentPagesPadding"
                      className="td-autosize text-center"
                      onClick={(e) => e.stopPropagation()}
                    >
                      <div className="d-flex justify-content-between align-items-center">
                        <span>
                          {caseProvider.checkID?.cheque_date
                            ? ""
                            : caseProvider.checkID?.date_check_requested && "Check Requested: "}
                          {caseProvider.checkID?.cheque_date
                            ? formatCalendarDate(caseProvider.checkID.cheque_date)
                            : formatTimestampDate(caseProvider.checkID?.date_check_requested)}
                        </span>
                        <span>{caseProvider?.check_number}</span>
                        <img
                          style={{
                            width: "35px",
                          }}
                          src={checkUpload}
                        />
                      </div>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
      {/* <NotesSectionDashboard pageName={"Notes"} /> */}
      {showMedicallBill && (
        <EditMedicalBill
          show={showMedicallBill}
          handleClose={handleMedBillClose}
          medicalBill={medBillData}
          refetchAll={refetchAll}
          specialitie={specialitiesList}
          tfData={tfData}
          // setData={setMedBillData}
          // updateMedicalStates={updateMedicalBillsState}
        />
      )}

      {showGenerateDocument && (
        <GenrateDocument
          show={true}
          handleClose={() => {
            addClickRecord(999, 8);
            setShowGenerateDocument(false);
          }}
          PageEntity="Treatment"
          PageEntityId={8}
          instanceId={instanceIdForGenragteDoc}
          dropdownName={dropdownName}
        />
      )}
      {showFaxWorkflow && (
        <FaxWorkflowModal
          show={showFaxWorkflow}
          onClose={() => setShowFaxWorkflow(false)}
          contactId={caseProvider?.treatment_location?.id}
          caseProviderId={caseProvider?.id}
          recipientName={caseProvider?.treatment_location?.name}
          faxNumber={caseProvider?.treatment_location?.fax}
          recipientPhone={caseProvider?.treatment_location?.phone_number}
        />
      )}
      {costRequestModalProps && (
        <CostRequestDetailedModal
          show={!!costRequestModalProps}
          onClose={() => {
            setCostRequestModalProps(null);
            refreshPendingCost();
          }}
          source_model="CaseProviders"
          source_id={caseProvider?.id}
          page_id={8}
          requests={costRequestTabs}
          {...costRequestModalProps}
        />
      )}
    </div>
  );
};

export default React.memo(TreatmentPageSimplePage);
